import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  blackColor,
  DatePickerField,
  CheckboxField,
  DRxTextareaStyle,
  DRxSelectStyle,
} from "../../../Theme";
import { YSButton } from "../../../uikit/YSButton";
import DRxInput from "../../../uikit/DRxInput";
import DRxTextarea from "../../../uikit/DRxTextarea";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import { AddAllergy, InitializeAllergy } from "../../../Apis/AuthApiServices";
import { useDispatch, useSelector } from "react-redux";
import { loadingDrugSearchAjax } from "../../../Redux/Slice/DrugSearchAjaxSlice";
import useFetch from "../../../CustomHooks/useFetch";
import { YSSelectSearch } from "../../../uikit/YSSelectSearch";
import { useState } from "react";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { loadingPatientDetails } from "../../../Redux/Slice/PatientDetailsSlice";

const initialStateAddAllergies = {
  DrugName: "",
  DrugId: "",
  AllergiesList: [],
  OtherReactions: "",
  OnsetDate: "",
  Note: "",
};

export default function AddAllergies(props: any) {
  const [AddorEditState, setAddorEditState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const doctorId = localStorage.getItem("doctorId");
  const patientId = sessionStorage.getItem("patientId");
  const Params = {
    doctorId: doctorId,
    patientId: patientId,
  };
  const { data, loading }: any = useFetch(Params, InitializeAllergy, []);

  const AddNewAllergy = async (values: any) => {
    try {
      const Postdata = {
        drugName: values.DrugName,
        drugId: values.DrugId,
        otherRecation: values.OtherReactions,
        note: values.Note,
        onSetDate: values.OnsetDate,
        patientId: data[0]?.patientId,
        doctorId: data[0]?.doctorId,
        selectedAllergies: values.AllergiesList,
      };
      const result = await AddAllergy(Postdata);

      if (result?.data?.digitalRxStatusCode === 200) {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          props.handleHidePopupClick();
          props.getAllergiesData(0);
          dispatch(loadingPatientDetails());
        }, 2000);
      } else {
        setAddorEditState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setAddorEditState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const dispatch = useDispatch();
  const DrugSearchAjaxState = useSelector((state: any) => {
    return { ...state.DrugSearchAjaxSlice };
  }); //redux data

  return (
    <>
      {loading ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"30vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Formik
          initialValues={initialStateAddAllergies}
          enableReinitialize={true}
          validationSchema={yup.object().shape({
            DrugName: yup
              .string()
              .required("Drug name is required.")
              .max(32)
              .min(4)
              .typeError("First four letters of Drug name are required."),

            OtherReactions: yup.string().when("AllergiesList", {
              is: (AllergiesList: any) =>
                !AllergiesList || AllergiesList.length === 0,
              then: yup
                .string()
                .required(
                  "Please enter your reaction or select from above reactions"
                ),
            }),
          })}
          onSubmit={(values) => {
            AddNewAllergy(values);
          }}
        >
          {(registerProps) => (
            <Form onSubmit={registerProps.handleSubmit}>
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={blackColor}
                      fontWeight={"400"}
                      htmlFor="searchby"
                      marginBottom={3}
                    >
                      Drug Name
                      <Typography
                        component="span"
                        color="error"
                        variant="body2"
                      >
                        *
                      </Typography>
                    </Typography>
                    <DRxSelectStyle>
                      {" "}
                      <YSSelectSearch
                        id="searchby"
                        options={
                          DrugSearchAjaxState?.Items?.map(
                            (item: any, index: any) => ({
                              id: item?.drugId,
                              label: item?.drugName,
                            })
                          ) ?? [{ id: "", label: "" }]
                        }
                        name="DrugName"
                        value={registerProps?.values?.DrugName}
                        onInputChange={(event: any, value: any) => {
                          registerProps.setFieldValue("DrugName", value);

                          let drugName = {
                            drugName: value,
                          };
                          if (value.length >= 4) {
                            dispatch(loadingDrugSearchAjax(drugName));
                          }
                        }}
                        onChange={(event: any, value: any) => {
                          registerProps.setFieldValue("DrugId", value.id);
                        }}
                        error={
                          registerProps.touched.DrugName &&
                          Boolean(registerProps.errors.DrugName)
                        }
                      />
                    </DRxSelectStyle>
                  </InputSMBoxStyle>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography
                    component="label"
                    color={blackColor}
                    variant="body2"
                  >
                    My Reactions to this drug are:{" "}
                    <Typography component="span" color="error" variant="body2">
                      *
                    </Typography>
                    <Typography component="span" variant="body2">
                      Please select or enter a reaction.
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
                marginBottom={2}
              >
                {data[0]?.allergyDetailsList?.map((item: any, index: any) => {
                  return (
                    <Grid item xs={12} md={4} lg={3} key={index}>
                      <CheckboxField>
                        <Field
                          name="AllergiesList"
                          id={index + "allergies"}
                          value={item?.allergyId}
                          type="checkbox"
                        />
                        <label htmlFor={index + "allergies"}>
                          {item?.allergyName}
                        </label>
                      </CheckboxField>
                    </Grid>
                  );
                })}
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="flex-start"
              >
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="otherR"
                      marginBottom={3}
                    >
                      Other Reactions
                      <Typography
                        component="span"
                        color="error"
                        variant="body2"
                      >
                        *
                      </Typography>
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body1"
                      ></Typography>
                    </Typography>{" "}
                    <Box>
                      <DRxInput
                        id="otherR"
                        name="OtherReactions"
                        type="text"
                        className=""
                        placeholder="Enter Your Reactions"
                      />
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="clinicextraname"
                      marginLeft={3}
                    >
                      Onset Date
                    </Typography>{" "}
                    <Box>
                      <DatePickerField>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="MM/dd/yyyy"
                            value={registerProps.values.OnsetDate}
                            onChange={(e) => {
                              registerProps.setFieldValue(
                                "OnsetDate",
                                moment(e).format("MM/DD/yyyy")
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={
                                  registerProps.touched.OnsetDate &&
                                  Boolean(registerProps.errors.OnsetDate)
                                }
                                onBlur={registerProps.handleBlur}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </DatePickerField>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="note"
                    >
                      Note
                    </Typography>{" "}
                    <Box>
                      <DRxTextareaStyle>
                        <DRxTextarea
                          id="note"
                          name="Note"
                          className=""
                          placeholder="Enter Notes"
                        />
                      </DRxTextareaStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12}>
                  <BtnSMGroupStyle style={{ textAlign: "right" }}>
                    <YSButton
                      size="large"
                      className=""
                      color="secondary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="button"
                      children={"Cancel"}
                      onClick={props.handleHidePopupClick}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Add"}
                    />{" "}
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      )}

      <YSSnackBar
        message={AddorEditState.message}
        variant={AddorEditState.variant}
        open={AddorEditState.open}
        handleClose={() => {
          setAddorEditState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
